import { useEffect } from 'react'
import { Navigate, useParams } from 'react-router'

import { addBreadcrumb } from '@shared/lib/sentry'

export function CategoryRedirect () {
  const params = useParams()
  
  // Use the most specific (deepest) slug - with new URL structure 
  // all categories are accessed via /catalog/:categorySlug
  const categorySlug = params.categorySubChildrenSlug 
    ?? params.categoryChildrenSlug 
    ?? params.categorySlug
  
  const newPath = categorySlug 
    ? `/catalog/${categorySlug}`
    : '/'
  
  useEffect(() => {
    const oldPath = window.location.pathname
    addBreadcrumb(
      `URL redirect: ${oldPath} → ${newPath}`,
      'navigation',
      'info'
    )
  }, [ newPath ])
  
  return <Navigate to={newPath} replace />
}
